/** 1 日のミリ秒。 */
export const DAY_MS = 86_400_000;

/**
 * 日付を「1970-01-01 (UTC) からの通日」で扱う。ワールドモデルの時刻はすべてこの通日。
 * タイムゾーンに左右されないよう、暦の計算は UTC で行う。
 */
export type DayNumber = number;

/** `YYYY-MM-DD` を通日にする。 */
export function dayNumber(iso: string): DayNumber {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
  if (!m) throw new Error(`日付の形式が不正: ${iso}`);
  const [y, mo, d] = [Number(m[1]), Number(m[2]), Number(m[3])];
  const ms = Date.UTC(y, mo - 1, d);
  const back = new Date(ms);
  if (back.getUTCFullYear() !== y || back.getUTCMonth() !== mo - 1 || back.getUTCDate() !== d) {
    throw new Error(`存在しない日付: ${iso}`);
  }
  return Math.round(ms / DAY_MS);
}

/** 通日を `YYYY/MM/DD` にする（端数は切り捨て）。 */
export function formatDay(n: DayNumber): string {
  const d = new Date(Math.floor(n) * DAY_MS);
  const mm = String(d.getUTCMonth() + 1).padStart(2, '0');
  const dd = String(d.getUTCDate()).padStart(2, '0');
  return `${d.getUTCFullYear()}/${mm}/${dd}`;
}

/** 通日の月（1〜12）。 */
export function monthOf(n: DayNumber): number {
  return new Date(Math.floor(n) * DAY_MS).getUTCMonth() + 1;
}
